import React, { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { AgencyModel, Environment, RespondAppCore } from 'pulsepoint-web-common'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AppSkeleton, { ConfirmationDialogContext, ScreenWidthCategoryContext, ToastContext } from 'app/common/AppSkeleton'
import { usePreventScreensaver } from './utils/usePreventScreenSaver'

const Home = () => {
  const [urlParams, setUrlParams] = useSearchParams()
  const navigate = useNavigate()
  const token = urlParams.get('sandbox-token')
  const isSandbox = token !== null && token !== ''
  const context = isSandbox ? 'SANDBOX_LINK' : 'PUBLIC'
  const allowedEnvironments: Environment[] = isSandbox ? ['SANDBOX'] : ['PRODUCTION']

  const isInIframe = window.self !== window.top
  const hasAgencyParam = urlParams.get('agencies') !== null || urlParams.get('agencyid') !== null
  const singleSelectedAgency = hasAgencyParam && !urlParams.get('agencies')?.includes(',') && !urlParams.get('agencyid')?.includes(',')

  usePreventScreensaver()

  ReactGA.initialize('G-BCNQJ8NG05')

  const agencyLoaded = (agency: AgencyModel) => {
    ReactGA.event("Agency Loaded", {
      category: 'User Interaction',
      action: 'Agency Loaded',
      custom_param: agency.shortName
    })

    if (singleSelectedAgency) {
      document.title = `PulsePoint Respond - ${agency.shortName}`
    } else {
      document.title = 'PulsePoint Respond'
    }
  }

  useEffect(() => {
    ReactGA.event("App Loaded", {
      category: 'User Interaction',
      action: 'App Loaded',
      custom_param: (urlParams.get('embed') === '1' || (isInIframe && hasAgencyParam)) ? 'EMBED' : context
    })
  }, [])

  return (
    <AppSkeleton>
      <ScreenWidthCategoryContext.Consumer>
        {screenWidthCategory => (
          <ToastContext.Consumer>
            {toastManager => (
              <ConfirmationDialogContext.Consumer>
                {dialogManager => (
                  <RespondAppCore
                    onAgencyLoaded={agencyLoaded}
                    searchParams={urlParams}
                    contextProviders={{
                      screenWidthCategory: screenWidthCategory,
                      toastManager: toastManager,
                      confirmationManager: dialogManager,
                    }}
                    appConfiguration={{
                      context: context,
                      isEmbedded: urlParams.get('embed') === '1' || (isInIframe && hasAgencyParam),
                      allowedEnvironments: allowedEnvironments,
                      showPublicPrivateOverrideControl: false
                    }}
                    onSelectAgency={agency => {
                      navigate(`/agency/${agency.agencyID}`, {
                        state: {
                          agency: agency
                        }
                      })
                    }}
                    onSelectIncident={incident => {
                      if (!urlParams.get('incident')) {
                        setUrlParams(prev => {
                          prev.set('incident', incident.recordID)
                          prev.set('agencies', incident.agencyID)
                          return prev
                        })
                      }

                      ReactGA.event("Click Incident", {
                        category: 'User Interaction',
                        action: 'Click Incident',
                        custom_param: incident.callTypeDescription()
                      })
                    }}
                  />
                )}
              </ConfirmationDialogContext.Consumer>
            )}
          </ToastContext.Consumer>
        )}
      </ScreenWidthCategoryContext.Consumer>
    </AppSkeleton>
  )
}

export default Home
